
import { pick, isEmpty } from 'lodash'

function cloneRoute (to, from) {
  var clone = {
    name: to.name,
    path: to.path,
    hash: to.hash,
    query: to.query,
    params: to.params,
    fullPath: to.fullPath,
    meta: to.meta
  }
  if (from) {
    clone.from = cloneRoute(from)
  }
  return Object.freeze(clone)
}

const MmpRouterSync = {
  install (Vue, options) {
    var mmpRouteStore = window.vue.getStore('mmpRoute')

    var moduleName = (options || {}).moduleName || 'route'

    var routerObj = window.vue.getInstance('router')

    var isTimeTraveling = false
    var currentPath

    mmpRouteStore.registerModule(moduleName, {
      namespaced: true,
      state: isEmpty(mmpRouteStore.state.route) ? cloneRoute(routerObj.currentRoute) : mmpRouteStore.state.route,
      mutations: {
        'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
          mmpRouteStore.state[moduleName] = cloneRoute(transition.to, transition.from)
        }
      }
    })

    mmpRouteStore.watch(
      function (state) { return state[moduleName] },
      function (route) {
        var fullPath = route.fullPath
        if (fullPath === currentPath) {
          return
        }
        if (currentPath != null) {
          isTimeTraveling = true
          routerObj.push(route)
        }
        currentPath = fullPath
      },
      { sync: true }
    )

    routerObj.afterEach(function (to, from) {
      if (isTimeTraveling) {
        isTimeTraveling = false
        return
      }
      currentPath = to.fullPath

      mmpRouteStore.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
    })

    Vue.isBack = Vue.prototype.$isBack = function (to) {
      return to.params.checkBack === undefined
    }

    Vue.goPage = Vue.prototype.$goPage = async function (to) {
      var replaceTo = pick(to, ['fullPath', 'hash', 'meta', 'name', 'params', 'path', 'query'])
      console.log('goPage', replaceTo)
      let isLogin = window.vue.getStore('root').state.session.authenticated
      // let isMobile = !window.vue.getStore('homeInfo').state.isDeskTopMode
      if (!isLogin) {
        if (replaceTo.name === 'MyDashbrd' || replaceTo.name === 'Inquiry' ) {
          var authConfirm = await Vue.popup.confirm(undefined, {title: '로그인', contents: '로그인이 필요한 메뉴입니다. <br> 로그인하시겠습니까?', okBtnNm: '로그인'})
          if (authConfirm) {
            let mmpAuthStore = window.vue.getStore('mmpAuth')
            mmpAuthStore.commit('SET_BEFORE_ROUTE', to)
            replaceTo = pick({name: 'Login'}, ['fullPath', 'hash', 'meta', 'name', 'params', 'path', 'query'])
            replaceTo.params = Object.assign({}, replaceTo.params, {checkBack: true})

            // history.pushState(replaceTo, '', '')
            routerObj.push(replaceTo).catch(() => {})
            return
          } else {
            return
          }
        }
      }

      replaceTo.params = Object.assign({}, replaceTo.params, {checkBack: true})
      // window.vue.getStore('mmpAuth').commit('SET_BEFORE_ROUTE', '')

      // history.pushState(replaceTo, '', '')
      routerObj.push(replaceTo).catch(() => {})
    }
  }
}
export default MmpRouterSync



// WEBPACK FOOTER //
// ./src/plugins/_common/MmpBeforeRouteCheck.js